<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">assignment</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a (click)="onSelect()">{{ data.dateAppli | date:'shortDate' }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.valeurMini'"></strong>
                <span>{{ data.mini | number }}</span>
            </li>
            <li *ngIf="data.maxi != 0">
                <strong [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.valeurMaxi'"></strong>
                <span>{{ data.maxi | number }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.taux'"></strong>
                <span>{{ data.taux | number:'1.3-3' }}</span>
            </li>
            <li *ngIf="liste.extraOptions?.typeBareme == TypeBareme.BAREME_SNCF">
                <strong [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.bareme.popin.constante'"></strong>
                <span>{{ (data.constante ?? 0) | number:'1.2-2' }}</span>
            </li>
        </ul>
    </div>
    <div *ngIf="data.maxi != 0" class="lvi-actions">
        <button mat-icon-button (click)="deleteBareme()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>